export default __webpack_public_path__ + "static/media/crystal.e4a4686d.svg";